import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nexus-row',
  templateUrl: './nexus-row.component.html',
  styleUrls: ['./nexus-row.component.scss']
})
export class NexusRowComponent implements OnInit {
  @Input() public row_label: string;
  @Input() public label_class: string;

  constructor() { }

  ngOnInit() {
  }

}
